import React from "react";
import { Link } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";

export default function CtaBanner({
  title = "Ready to Simplify Your Accounting?",
  // No customer counts: there are none to count yet, and a number that has to
  // be walked back later costs more than it ever earned.
  subtitle = "Set up your company, send your first invoice, and see how it fits the way you work.",
  showSecondary = true,
  showChecks = true,
}) {
  return (
    <section className="section-container py-14">
      <div className="rounded-2xl bg-navy px-6 py-12 text-center sm:px-12">
        <h2 className="text-2xl font-bold text-white sm:text-3xl">{title}</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-slate-300">
          {subtitle}
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-4">
          <Link to="/register" className="btn-primary">
            Get Started
          </Link>
          {showSecondary && (
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center rounded-lg border border-white/25 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              View Pricing
            </Link>
          )}
        </div>
        {showChecks && (
          <div className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-300">
            {["Billed yearly", "Setup in minutes", "Cancel any time"].map(
              (item) => (
                <span key={item} className="inline-flex items-center gap-1.5">
                  <FiCheckCircle className="text-emerald-400" size={14} />
                  {item}
                </span>
              ),
            )}
          </div>
        )}
      </div>
    </section>
  );
}
